import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
// @ts-ignore
import { DragDropContainer, DropTarget } from 'react-drag-drop-container'
import { Game9Map, getRndFromArray, useStore, GameStatus, shuffleArray, Game8Map } from '../lib'
import { Guide, Image as Img, Loader, ModalAlert, ModalImage, ScoreStats, SideNav } from '../components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { GameFrame } from './GameFrame'

export const Game9 = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>((window.innerWidth * 0.55) / 3)
  const [displayedItems, setDisplayedItems] = useState<any[]>([])
  const [displayedLabels, setDisplayedLabels] = useState<any[]>([])
  const [status, setStatus] = useState<{ [key: string]: GameStatus }>({})
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>(0)
  const history = useHistory()
  const refGuide: any = useRef(null)
  const refModalAlert: any = useRef(null)
  const refModalImage: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()

  const preloadImages = async () => {
    const onImgLoad = async (imageEl: HTMLImageElement) => {
      return new Promise(resolve => {
        imageEl.onload = () => resolve(imageEl)
      })
    }
    const allItems = getRndFromArray([...Game9Map.items], 9)
    const all = allItems.map((a: any) => a.img)
    for (const imgSrc of all) {
      const img = new Image()
      img.src = imgSrc
      await onImgLoad(img)
    }
    setDisplayedItems(shuffleArray(allItems))
    setDisplayedLabels(shuffleArray(allItems))
    setIsInitialized(true)
    refGuide?.current?.openModal(Game9Map.intro)
    return true
  }

  useEffect(() => {
    if (!isInitialized) {
      preloadImages()
      patchState({ score: 0, errors: 0 }) // todo
    }
  }, [isInitialized])

  const onDrop = (event: any, targetAnimalId: string) => {
    if (event.dragData === targetAnimalId) {
      patchState({ score: state.score + 1 })
      setStatus({ ...status, ...{ [targetAnimalId]: 'success' } })
      refGuide?.current?.openModal([displayedItems.filter((a: any) => a.id === targetAnimalId)[0].comment])
    } else {
      patchState({ errors: state.errors + 1 })
      setStatus({ ...status, ...{ [targetAnimalId]: 'error' } })
      const t = setTimeout(() => setStatus({ ...status, ...{ [targetAnimalId]: null } }), 500)
    }
    let countSuccess = 0
    for (const s of Object.keys(status)) {
      if (status[s] === 'success') {
        countSuccess++
      }
    }
    const isLast = countSuccess + 1 === displayedItems.length
    if (isLast) {
      const timeMs = +new Date() - gameStartTime
      patchState({
        timeMs: state.timeMs + timeMs,
        games: { ...state.games, game9: { score: state.score, errors: state.errors, timeMs } },
      })
      setGameEndTime(+new Date())
      refGuide.current?.playSound()
      refGuide?.current?.onGameEnd(state.errors)
    }
  }

  const showAnimalDetail = (animal: any) => {
    refModalImage?.current?.openModal(animal?.img)
  }

  const exitGame = () => {
    setDisplayedItems([])
    setIsInitialized(false)
    setTimeout(() => history.push('/dashboard'))
  }

  if (!isInitialized || !displayedItems) {
    return <Loader />
  }
  return (
    <div className="view background-summer">
      <div className="view-content p-5 text-black">
        <h1 className="text-3xl text-center font-bold w-full">K čemu slouží</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game9Map.intro} />
        <Guide
          ref={refGuide}
          isWinter={false}
          hasWinterGearA={true}
          hasWinterGearB={true}
          onClose={() => (gameEndTime > 0 ? setIsFinished(true) : null)}
        />
        <GameFrame
          isFinished={isFinished}
          onExit={exitGame}
          childrenLeft={displayedItems.map(animal => (
            <div
              className="w-1/3 h-1/3 border overflow-hidden"
              style={{
                backgroundColor: status[animal.id] === 'error' ? 'red' : status[animal.id] === 'success' ? 'green' : '',
                borderColor:
                  status[animal.id] === 'error' ? 'red' : status[animal.id] === 'success' ? 'green' : 'white',
                borderWidth: '2px',
              }}
              key={animal.id}
            >
              {/*<div className="w-1/3 h-1/3 overflow-hidden" style={{ backgroundColor: status[animal.id] === 'error' ? 'red' : status[animal.id] === 'success' ? 'green' : '' }} key={animal.id}>*/}
              <DropTarget
                targetKey="animal"
                highlightClassName={!status[animal.id] ? 'highlighted' : ''}
                onHit={(e: any) => (!status[animal.id] ? onDrop(e, animal.id) : null)}
              >
                <Img
                  src={animal.img}
                  title={status[animal.id] === 'success' ? animal.label : undefined}
                  scale={1.66}
                  width={`${imgWidth}px`}
                  padding={'1rem'}
                  hasError={status[animal.id] === 'error'}
                  onClick={() => (status[animal.id] === 'success' ? showAnimalDetail(animal) : null)}
                  // imgFilter={status[animal.id] === 'success' ? 'contrast(120%) brightness(170%)' : status[animal.id] === 'error' ? 'blur(3px)' : ''}
                  imgFilter={
                    status[animal.id] === 'success'
                      ? 'grayscale(100%)'
                      : status[animal.id] === 'error'
                      ? 'blur(3px)'
                      : ''
                  }
                  onLabelClick={() => showAnimalDetail(animal)}
                />
              </DropTarget>
            </div>
          ))}
          childrenRight={displayedLabels.map(animal => (
            <div className="w-1/3" key={`${animal.id}_label`}>
              <DragDropContainer targetKey="animal" dragData={animal.id} noDragging={status[animal.id] === 'success'}>
                <div
                  className={`btn btn-block w-52 ${
                    status[animal.id] === 'success' ? 'btn-disabled' : 'text-black'
                  } mb-5 glass`}
                >
                  {animal.label}
                </div>
              </DragDropContainer>
            </div>
          ))}
        />
        <div>
          <ModalAlert ref={refModalAlert} />
        </div>
        <div>
          <ModalImage ref={refModalImage} />
        </div>
      </div>
    </div>
  )
}
